import React from 'react'
import { LightbulbIcon } from 'lucide-react'

interface InboxSuggestBannerProps {
  title: string
  description?: string
  confirmLabel?: string
  onConfirm: () => void
  onDismiss: () => void
}

/** Slim confirm-only auto-suggest banner (missed call, unanswered SMS, etc.) */
export function InboxSuggestBanner({
  title,
  description,
  confirmLabel = 'Create task',
  onConfirm,
  onDismiss,
}: InboxSuggestBannerProps) {
  return (
    <div className="flex-shrink-0 flex items-center gap-2 border-y border-amber-200 bg-amber-50/80 px-4 py-2 text-xs">
      <LightbulbIcon className="w-3.5 h-3.5 text-amber-600 flex-shrink-0" />
      <span className="flex-1 min-w-0 font-medium text-amber-900 truncate">{title}</span>
      {description && (
        <span className="hidden sm:inline text-amber-700 truncate max-w-[12rem]">{description}</span>
      )}
      <button
        type="button"
        onClick={onConfirm}
        className="flex-shrink-0 px-2.5 py-1 text-[11px] font-medium bg-amber-600 text-white rounded hover:bg-amber-700"
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="flex-shrink-0 px-2 py-1 text-[11px] font-medium text-amber-800 hover:underline"
      >
        Dismiss
      </button>
    </div>
  )
}
